import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/Guest-blank.webp";
import ThumbImg from "../../assets/images/conversations/blank.png";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: rs-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .rs-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .rs-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 - HERO
  ══════════════════════════════════════ */
  .rs-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .rs-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .rs-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .rs-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rs-hero__title.rs-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .rs-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .rs-hero__spotify.rs-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .rs-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .rs-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .rs-hero__right.rs-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .rs-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .rs-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .rs-yt-thumb:hover img { opacity: 0.85; }
  .rs-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .rs-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .rs-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .rs-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 - BODY
  ══════════════════════════════════════ */
  .rs-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rs-body.rs-visible { opacity: 1; transform: translateY(0); }
  .rs-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .rs-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 - OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .rs-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rs-guest.rs-visible { opacity: 1; transform: translateY(0); }
  .rs-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .rs-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .rs-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .rs-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .rs-inner { padding-left: 32px; padding-right: 32px; }
    .rs-hero { padding-top: 32px; padding-bottom: 48px; }
    .rs-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .rs-hero__title { font-size: 24px; }
    .rs-hero__left { gap: 16px; }
    .rs-guest__title { font-size: 24px; margin-bottom: 24px; }
    .rs-guest__photo-bg { width: 260px; height: 300px; }
    .rs-guest__name { font-size: 24px; margin-top: 18px; }
    .rs-body__para { font-size: 14px; margin-bottom: 12px; }
    .rs-body { padding-bottom: 48px; }
    .rs-guest { padding-bottom: 48px; }
    .rs-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .rs-inner { padding-left: 16px; padding-right: 16px; }
    .rs-hero { padding-top: 51px; padding-bottom: 30px; }
    .rs-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .rs-hero__left { gap: 30px; }
    .rs-hero__title { font-size: 30px; }
    .rs-body__para { font-size: 16px; margin-bottom: 10px; }
    .rs-guest__title { font-size: 30px; margin-bottom: 20px; text-align:left; }
    .rs-guest__photo-bg { width: 100%; height: 386px; }
    .rs-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .rs-body { padding-bottom: 30px; }
    .rs-guest { padding-bottom: 30px; }
    .rs-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("rs-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "YOUTUBE_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="rs-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 43 Rohan Sharvan"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="rs-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 43 Rohan Sharvan thumbnail" />
      <div className="rs-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="rs-hero">
      <div className="rs-inner">
        <div className="rs-hero__grid">
          <div className="rs-hero__left">
            <h1 ref={titleRef} className="rs-hero__title">
              EP 43 | A Deep Dive into Electric Trucks | Tresa Motors | Rohan Sharvan
            </h1>
            <div ref={spotifyRef} className="rs-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/4KcJF1PMqm3JJA13UxHutq?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 43 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="rs-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="rs-body">
      <div className="rs-inner">
        <p className="rs-body__para">
          Apart from causing a lot of traffic, commercial trucks play a very key role in running everyday life in India. However, over the years, these internal combustion engine (ICE) trucks have been major contributors to environmental pollution. Addressing this particular issue today, we have Rohan Shravan, the CEO at Tresa Motors, one of the few companies that is actively building intellectual property (IP) in India, and that too in a space largely dominated by legacy players. This is going to be a fun conversation. Rohan, welcome to the program.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="rs-guest">
      <div className="rs-inner">
        <h2 className="rs-guest__title">Our Guest</h2>
        <div>
          <div className="rs-guest__photo-bg">
            <img src={GuestImg} alt="Rohan Sharvan" />
          </div>
          <p className="rs-guest__name">Rohan SHARVAN</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep43RohanSharvan() {
  return (
    <>
      <style>{CSS}</style>
      <div className="rs-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}